

















































































import { IVirtualRooma } from "@/@types/hotel/virtual_rooms";
import { IProductCard } from "@/@types/menu/menu/menu";
import { ICart, IOrder } from "@/@types/orders/new-order";
import { Component, Prop, Vue } from "vue-property-decorator";

import BarOrderItem from "../bar-order-item.vue";
import DishSettings from "./dish-settings.vue";

@Component({ components: { BarOrderItem, DishSettings } })
export default class BarOrderConstructorOrder extends Vue {
  @Prop({ type: Number, default: 0 }) guestIndex!: number;
  @Prop({ type: Object, default: null }) vroom!: IVirtualRooma;
  @Prop({ type: String, default: null }) orderCoast!: string;
  @Prop({ type: Object, default: null }) order!: IOrder;
  @Prop({ type: Array, default: () => [] }) menu!: Array<IProductCard>;

  dishid = "";

  get dish(): ICart | null {
    const dish = this.order.cart.find((d) => d.item_id == this.dishid);
    return dish ? dish : null;
  }

  get bacground(): string {
    if (this.order.status == "new") return "bg-success text-dark";
    if (this.order.status == "active") return "bg-light text-dark";
    if (this.order.status == "closed") return "bg-secondary text-light";
    if (this.order.status == "cancel") return "bg-danger text-light";

    return "";
  }

  openDishSetting(id: string): void {
    this.dishid = id;
    this.$nextTick(() => this.$bvModal.show("dish-settings"));
  }

  changeCount(id: string, count: number): void {
    const i = this.order.cart.findIndex((el) => el.item_id == id);
    if (i < 0) return;
    if (count == 0) this.order.cart.splice(i, 1);
    else this.order.cart[i].count = count;
    this.$emit("changeCount", { cart: this.order.cart });
  }
}
